import { Link } from "react-router-dom"

export default function MobileSidebarDrawer({ open, onClose }: { open: boolean; onClose: () => void }) {
    const MENU_ITEMS = [
        {
            label: 'Dùng phiên bản nhanh',
            href: 'https://nhanh.thuocsi.vn/',
            icon: '/theme/Vector.svg',
            border: true,
        },
        {
            label: 'Trang chủ',
            href: '/',
            icon: '/theme/Homepage.svg',
        },
        {
            label: 'Sản phẩm',
            href: '/products',
            icon: '/theme/Product_List.svg',
        },
        {
            label: 'Mã giảm giá',
            href: '/promo-codes',
            icon: '/theme/Discount_Code.svg',
        },
        // {
        //     label: 'Nhà bán hàng',
        //     href: '/discounts',
        //     icon: '/theme/Store.svg',
        //     border: true,
        // },
        {
            label: 'Thông tin tài khoản',
            href: '/my-account',
            icon: '/theme/Account.svg',
        },
        {
            label: 'Đơn hàng của tôi',
            href: '/my-order',
            icon: '/theme/Tra_Cuu_Van_Don.svg',
        },
        {
            label: 'Giới thiệu',
            href: '/gioi-thieu',
            icon: '/theme/Feedback.svg',
        },
        {
            label: 'Điểm tích lũy',
            href: '/users/loyalty_points',
            icon: '/theme/Reward_Points.svg',
        },
        // {
        //     label: 'Thống kê',
        //     href: '/',
        //     icon: '/theme/Thong_ke.svg',
        // },
        // {
        //     label: 'Tra cứu mã QR',
        //     href: '/',
        //     icon: '/theme/QR_Code_1.svg',
        // },
        {
            label: 'Sản phẩm đã xem',
            href: '/productviewed',
            icon: '/theme/Da_Xem.svg',
        },
        {
            label: 'Sản phẩm quan tâm',
            href: '/user/wishlist',
            icon: '/theme/Wishlist.svg',
        },
        {
            label: 'Hướng dẫn đặt hàng',
            href: '/huong-dan',
            icon: '/theme/Huong_dan_dat_hang.svg',
        },
        {
            label: 'Điều khoản sử dụng',
            href: '/dieu-khoan-su-dung',
            icon: '/theme/Policy-default.svg',
        },
    ]

    const SOCIALS = [
        { name: 'facebook', href: 'https://www.facebook.com/tamhanhpharma', icon: 'https://cdn-web-mobile-next.thuocsi.vn/images/menuHamburger/fb1.svg' },
        { name: 'tiktok', href: 'https://www.tiktok.com/@tamhanhpharma.com', icon: 'https://cdn-web-mobile-next.thuocsi.vn/images/menuHamburger/tiktok1.svg' },
        { name: 'linkedin', href: 'https://cdn-web-mobile-next.thuocsi.vn/images/menuHamburger/linkedin1.svg', icon: 'https://cdn-web-mobile-next.thuocsi.vn/images/menuHamburger/linkedin1.svg' },
        { name: 'zalo', href: 'https://zalo.me/1836616064223034882', icon: 'https://cdn-web-mobile-next.thuocsi.vn/images/menuHamburger/zalo1.svg' },
    ]

    const CERTS = [
        {
            href: 'http://online.gov.vn/Home/WebDetails/52192',
            icon: 'https://cdn-web-mobile-next.thuocsi.vn/images/footer/verify_mobile.png',
        },
        {
            href: 'http://online.gov.vn/Home/AppDetails/2786',
            icon: 'https://cdn-web-mobile-next.thuocsi.vn/images/footer/verify_mobile.png',
        },
        {
            href: 'https://cystack.net/projects/tamhanhpharma',
            icon: 'https://cdn-web-mobile-next.thuocsi.vn/images/footer/cystack.svg',
        },
    ]


    if (!open) return null

    return (
        <div
            role="presentation"
            className="MuiDrawer-root MuiDrawer-modal styles_mobileSidebar_container__3f0CA"
            style={{ position: 'fixed', inset: 0, zIndex: 1300 }}
        >
            {/* Backdrop */}
            <div
                className="MuiBackdrop-root"
                aria-hidden="true"
                onClick={onClose}
                style={{ opacity: 1 }}
            />

            {/* Drawer */}
            <div
                className="MuiPaper-root MuiDrawer-paper MuiDrawer-paperAnchorLeft MuiPaper-elevation16"
                tabIndex={-1}
            >
                {/* HEADER */}
                <div className="styles_containerCustomter__OLYWi">
                    <h5 className="styles_textUser__5C_Vo">
                        Chào <span className="styles_textUserBold__utR2Q">Nhà thuốc Vũ Huy</span>
                    </h5>

                    <button
                        className="MuiButtonBase-root MuiIconButton-root styles_exitIcon__HOvIM"
                        type="button"
                        onClick={onClose}
                        aria-label="close"
                    >
                        <img
                            src="https://cdn-web-mobile-next.thuocsi.vn/images/menuHamburger/exit.svg"
                            alt="close"
                        />
                    </button>
                </div>

                {/* LEVEL / POINT */}
                <div className="styles_box2__OZLAt">
                    <div className="styles_table__h6VT9">
                        <div className="styles_quickView__MzeMa">

                            <div className="styles_leftInformation__cL_CO">
                                <h5 className="styles_textLevel__doJb0">Cấp bậc</h5>
                                <img
                                    src="https://cdn-web-mobile-next.thuocsi.vn/images/header-v2/BAC.svg"
                                    alt="level"
                                />
                            </div>

                            <div className="styles_line__mpKHu" />

                            <div className="styles_rightInformation__UW9ZG">
                                <div className="styles_top__SN_GZ">
                                    <img
                                        src="https://cdn-web-mobile-next.thuocsi.vn/images/menuHamburger/medal.svg"
                                        alt="medal"
                                    />
                                    <h6 className="styles_textLevel__doJb0">Điểm tích lũy</h6>
                                </div>
                                <div className="styles_bottom__SBZ6O">
                                    <h6 className="styles_textPoint__we2Bi">0</h6>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {/* MENU LIST */}
                <div className="styles_groupTable__s_bK0">

                    {MENU_ITEMS.map((item, i) =>
                        item.href.startsWith('http') ? (
                            <a
                                key={i}
                                className={`styles_mobile_rootBase__8z7PQ styles_navItem__SgbRN ${item.border ? 'styles_borderBottom__a5u7p' : ''}`}
                                href={item.href}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img src={item.icon} alt="" />
                                <h6 className="styles_textName__OPCtF">{item.label}</h6>
                            </a>
                        ) : (
                            <Link
                                key={i}
                                className={`styles_mobile_rootBase__8z7PQ styles_navItem__SgbRN ${item.border ? 'styles_borderBottom__a5u7p' : ''}`}
                                to={item.href}
                                onClick={onClose}
                            >
                                <img src={item.icon} alt="" />
                                <h6 className="styles_textName__OPCtF">{item.label}</h6>
                            </Link>
                        )
                    )}

                    <div
                        className={`styles_mobile_rootBase__8z7PQ styles_navItem__SgbRN styles_borderBottom__a5u7p`}
                        onClick={() => {
                            localStorage.removeItem("token")
                            localStorage.removeItem("user")
                            window.location.href = `/`;
                        }}
                    >
                        <img src="/theme/Log_Out.svg" alt="" />
                        <h6 className="styles_textName__OPCtF">Đăng Xuất</h6>
                    </div>

                </div>

                {/* SOCIAL */}
                <div className="styles_groupSocialMedia__EkxTR">
                    <h6 className="styles_textSocialMedia__fMj76">Kết nối với chúng tôi</h6>
                </div>

                <div className="styles_groupSocialMedia__EkxTR">
                    {SOCIALS.map((s, i) => (
                        <a
                            key={i}
                            href={s.href}
                            target="_blank"
                            rel="noreferrer"
                            aria-label="social media Link"
                        >
                            <span
                                style={{
                                    boxSizing: 'border-box',
                                    display: 'inline-block',
                                    overflow: 'hidden',
                                    width: 'initial',
                                    height: 'initial',
                                    background: 'none',
                                    opacity: 1,
                                    border: 0,
                                    margin: 0,
                                    padding: 0,
                                    position: 'relative',
                                    maxWidth: '100%',
                                }}
                            >
                                <span
                                    style={{
                                        boxSizing: 'border-box',
                                        display: 'block',
                                        width: 'initial',
                                        height: 'initial',
                                        background: 'none',
                                        opacity: 1,
                                        border: 0,
                                        margin: 0,
                                        padding: 0,
                                        maxWidth: '100%',
                                    }}
                                >
                                    <img
                                        alt=""
                                        aria-hidden="true"
                                        src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%20width='24'%20height='24'/%3e"
                                        style={{
                                            display: 'block',
                                            maxWidth: '100%',
                                            width: 'initial',
                                            height: 'initial',
                                            background: 'none',
                                            opacity: 1,
                                            border: 0,
                                            margin: 0,
                                            padding: 0,
                                        }}
                                    />
                                </span>

                                <img
                                    alt={s.name}
                                    src={s.icon}
                                    decoding="async"
                                    style={{
                                        position: 'absolute',
                                        inset: 0,
                                        boxSizing: 'border-box',
                                        padding: 0,
                                        border: 'none',
                                        margin: 'auto',
                                        display: 'block',
                                        width: 0,
                                        height: 0,
                                        minWidth: '100%',
                                        maxWidth: '100%',
                                        minHeight: '100%',
                                        maxHeight: '100%',
                                    }}
                                />
                            </span>
                        </a>
                    ))}
                </div>

                {/* CERTIFICATE */}
                <div className="styles_groupCertificateIcons__wPSGG">
                    {CERTS.map((c, i) => (
                        <a
                            key={i} href={c.href}
                            target="_blank"
                            rel="noreferrer"
                            aria-label="Certificate Link"
                        >
                            <div className="styles_mt2__nKIhj">
                                <span
                                    style={{
                                        boxSizing: 'border-box',
                                        display: 'inline-block',
                                        overflow: 'hidden',
                                        width: 'initial',
                                        height: 'initial',
                                        background: 'none',
                                        opacity: 1,
                                        border: 0,
                                        margin: 0,
                                        padding: 0,
                                        position: 'relative',
                                        maxWidth: '100%',
                                    }}
                                >
                                    <span
                                        style={{
                                            boxSizing: 'border-box',
                                            display: 'block',
                                            width: 'initial',
                                            height: 'initial',
                                            background: 'none',
                                            opacity: 1,
                                            border: 0,
                                            margin: 0,
                                            padding: 0,
                                            maxWidth: '100%',
                                        }}
                                    >
                                        <img
                                            alt=""
                                            aria-hidden="true"
                                            src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%20width='85'%20height='26'/%3e"
                                            style={{
                                                display: 'block',
                                                maxWidth: '100%',
                                                width: 'initial',
                                                height: 'initial',
                                                background: 'none',
                                                opacity: 1,
                                                border: 0,
                                                margin: 0,
                                                padding: 0,
                                            }}
                                        />
                                    </span>

                                    <img
                                        src={c.icon}
                                        decoding="async"
                                        style={{
                                            position: 'absolute',
                                            inset: 0,
                                            boxSizing: 'border-box',
                                            padding: 0,
                                            border: 'none',
                                            margin: 'auto',
                                            display: 'block',
                                            width: 0,
                                            height: 0,
                                            minWidth: '100%',
                                            maxWidth: '100%',
                                            minHeight: '100%',
                                            maxHeight: '100%',
                                            objectFit: 'contain',
                                        }}
                                        alt=""
                                    />
                                </span>
                            </div>
                        </a>

                    ))}
                </div>
            </div>
        </div>
    )
}
